export default function isValidDate(date: Date): boolean {
  return (
    typeof date === 'object' && typeof date.getTime === 'function' && !Number.isNaN(date.getTime())
  );
}
